import { render } from "./feed.vue?vue&type=template&id=a8b43694&scoped=true"
import script from "./feed.vue?vue&type=script&lang=js"
export * from "./feed.vue?vue&type=script&lang=js"

import "./feed.vue?vue&type=style&index=0&id=a8b43694&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8b43694"

export default script